import axios from 'axios'

export default {
    namespaced: true,
    state: {
        checkLists: [],
        checkListsWithoutPoints: [],
        comparisonList: [],
    },
    mutations: {
        CLEAR_DATA(state) {
            state.checkLists = []
        },
        FETCH_CL(state, payload) {
            state.checkLists = payload
            state.comparisonList = JSON.parse(JSON.stringify(state.checkLists))
        },
        FETCH_CL_WITHOUT_POINTS(state, payload) {
            state.checkListsWithoutPoints = payload
        },
        ADD_CL(state, payload) {
            state.checkLists.push(payload)
            state.comparisonList.push(JSON.parse(JSON.stringify(payload)))
        },
        EDIT_CL(state, payload) {
            const index = state.checkLists.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                Object.assign(state.checkLists[index], payload.data)
                state.comparisonList[index] = JSON.parse(JSON.stringify(payload.data))
            }
        },
        DEL_CL(state, payload) {
            const index = state.checkLists.findIndex(
                item => item.id === payload
            )
            if (index !== -1) {
                state.checkLists.splice(index, 1)
            }
        },
        DEL_C_L_ITEM(state, payload) {
            const index = state.checkLists[payload.list_index].check_list_items.findIndex(
                item => item.id === payload.id
            )
            if (index !== -1) {
                state.checkLists[payload.list_index].check_list_items.splice(index, 1)
                state.comparisonList[payload.list_index].check_list_items.splice(index, 1)
            }
        },
        ADD_C_L_ITEM(state, payload) {
            state.checkLists[payload.index].check_list_items = payload.data
            state.comparisonList[payload.index].check_list_items = JSON.parse(JSON.stringify(payload.data))
        },
        EDIT_C_L_ITEM(state, payload) {
            Object.assign(state.comparisonList[payload.index].check_list_items[payload.idx], state.checkLists[payload.index].check_list_items[payload.idx])
        },
        ADD_C_L_EMPTY_ITEM(state, payload) {
            state.checkLists[payload.id].check_list_items.push(payload.obj)
        },
        DEL_C_L_EMPTY_ITEM(state, payload) {
            state.checkLists[payload].check_list_items = state.checkLists[payload].check_list_items.filter(obj => obj.id)
        },
    },
    actions: {
        fetch({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                if (state.checkLists.length) {
                    resolve()
                } else {
                    axios.get(
                        '/api/root/check-list'
                    ).then(({data}) => {
                        commit('FETCH_CL', data.data)
                        resolve()
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        getBaseCheckListsWithoutPoints({commit, dispatch, state}) {
            return new Promise((resolve, reject) => {
                axios.get(
                    '/api/root/check-list/cl-without-points'
                ).then(({data}) => {
                    commit('FETCH_CL_WITHOUT_POINTS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        add({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/root/check-list',
                    data
                ).then(({data}) => {
                    commit('ADD_CL', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({dispatch, commit}, data) {
            return new Promise((resolve) => {
                axios.put(
                    '/api/root/check-list/' + data.id,
                    data
                ).then(({data}) => {
                    commit('EDIT_CL', data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch, commit}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/check-list/' + itemId,
                ).then(() => {
                    commit('DEL_CL', itemId)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        saveCLI({dispatch, commit, state}, index) {
            let items = state.checkLists[index].check_list_items.filter(obj => !obj.id)
            items = items.filter(obj => obj.name !== '')
            if(items.length > 0) {
                return new Promise((resolve) => {
                    axios.post(
                        '/api/root/check-list/' + state.checkLists[index].id + '/check-list-item',
                        items
                    ).then(({data}) => {
                        commit('ADD_C_L_ITEM', {data: data.data, index: index})
                        resolve({text: 'Данные сохранены успешно!', type: 'success'})
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, {root: true})
                    })
                })
            } else {
                return {text: 'Убедитесь, что вы добавили новый пункт и заполнили все поля', type: 'warning'}
            }
        },
        updateCLI({dispatch, commit, state}, payload) {
            let item = state.checkLists[payload.index].check_list_items[payload.idx]
            if (item) {
                return new Promise((resolve) => {
                    axios.put(
                        '/api/root/check-list/' + item.check_list_id + '/check-list-item/' + item.id,
                        item
                    ).then(({data}) => {
                        commit('EDIT_C_L_ITEM', {index: payload.index, idx: payload.idx})
                        resolve({text: 'Данные сохранены успешно!', type: 'success'})
                    }).catch((error)=>{
                        dispatch('checkUnauthenticated', error, {root: true})
                    })
                })
            }
        },
        deleteItem({commit, dispatch}, item){
            return new Promise((resolve) => {
                axios.delete(
                    '/api/root/check-list/' + item.list_id + '/check-list-item/' + item.point_index,
                ).then((data) => {
                    commit('DEL_C_L_ITEM', {id: item.point_index, list_index: item.list_index})
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        addCLI({commit}, item) {
            commit('ADD_C_L_EMPTY_ITEM', item)
        },
        deleteEmptyItem({commit}, list_id) {
            commit('DEL_C_L_EMPTY_ITEM', list_id)
        },
    }
}
